module.exports = __webpack_public_path__ + "img/undraw_grad.13840a82.svg";